export default __webpack_public_path__ + "static/repat-about-50c934c16324ac2cd46a4826326594eb.png";